<section id='membership-options'>
  <div class='bg2' style='padding-top:80px;padding-bottom:100px;height: 550px;' fxHide.lt-lg fxLayout="column"
    fxLayoutAlign="center center">
    <img src="assets/images/handicap_plus_long_logo.png">
  </div>
  <div fxShow.lt-lg fxHide.gt-md fxLayout="column" fxLayoutAlign="center center">
    <img src="assets/images/handicap_plus_long_logo.png" width="90%">
  </div>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div fxLayout="column" fxLayoutAlign="start center" style="padding:10px; max-width: 90%;">
      <h1>Find a club, join, get stats!</h1>
      <p>If you haven't had the time to check out our Handicap+ program, I suggest you take a few minutes to find a club
        near you and join.</p>
      <p>We are currently offering our Handicap+ software for $7 for the whole year. That's a 65% discount.</p>
    </div>
  </div>
  <h2>Here are some instructions to get you started: </h2>

  <div fxShow.xs fxHide.gt-xs>
    <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="space-around start" fxLayoutalign.xs="center center">
      <div fxFlex="45" fxFlex.xs="100" fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start stretch"
        fxLayoutAlign.xs="center center" style="min-height: 400px;" fxLayoutGap.xs="10px">
        <div fxLayout="column" fxLayoutAlign="space-between center" style="padding:20px;" class="enterprise" fxFlex="50"
          fxFlex.xs="100">
          <h2>Get the app</h2>
          <p>
            We have moved away from the app store to provide you with a faster and more reliable service. So please,
            click on this button to get our new Progressive Web App. As you can see, there are many options for you to
            get started with only one click on a button.
          </p>
          <button mat-raised-button class='orange-button big-button' (click)='getApp()'>GET THE APP</button>
        </div>
        <div class="enterprise" fxFlex="50" fxFlex.xs="100" fxLayout="row wrap" fxLayoutAlign="space-around center">
          <img src="assets/images/create-options.png" width="100%">
        </div>
      </div>
      <div fxFlex="45" fxFlex.xs="100" fxLayout="row wrap" fxLayoutAlign="start stretch" style="min-height: 400px;">
        <div fxLayout="column" fxLayoutAlign="space-between center" style="padding:20px;" class="enterprise" fxFlex="50"
          fxFlex.xs="100">
          <h2>Confirm your Handicap Id</h2>
          <p>
            Before we go any further, use our Search Golfer feature to see if you've had a Handicap Id before. If you've
            had a GHIN in the past, there is a good change that it was converted to a Handicap Id. Please note that you
            cannot do partial search on the first name. You can put a space, but it's preferred if you enter your full
            name. Even if your Hdcp Id is Inactive, it's still yours and you should use it in the next step.
          </p>
        </div>
        <div class="enterprise" fxFlex="100">
          <img src="assets/images/find-golfer.png" width="100%">
        </div>
      </div>

      <div fxFlex="45" fxFlex.xs="100" fxLayout="row wrap" fxLayoutAlign="start stretch" style="min-height: 400px;">
        <div fxLayout="column" fxLayoutAlign="space-between center" style="padding:20px;" class="enterprise" fxFlex="50"
          fxFlex.xs="100">
          <h2>Update your profile</h2>
          <p>
            Now that you have your correct Handicap Id, take a few more minutes to update it in your profile. If you
            didn't find one in the previous step, don't worry about it. We will create one for you after you join our
            club.
          </p>
        </div>
        <div class="enterprise" fxFlex="100">
          <img src="assets/images/profile.png" width="100%">
        </div>
      </div>

      <div fxFlex="45" fxFlex.xs="100" fxLayout="row wrap" fxLayoutAlign="start stretch" style="min-height: 400px;">
        <div fxLayout="column" fxLayoutAlign="space-between center" style="padding:20px;" class="enterprise" fxFlex="50"
          fxFlex.xs="100">
          <h2>Find a Club</h2>
          <p>
            You are now ready to find a club. From the menu (top left), click on find a club, you can find a club based
            on GPS Location or by providing your Zip Code. Select the club nearest to you.
          </p>
        </div>
        <div class="enterprise" fxFlex="100">
          <img src="assets/images/find-club.gif" width="100%">
        </div>
      </div>

      <div fxFlex="45" fxFlex.xs="100" fxLayout="column" fxLayoutAlign="start stretch" style="min-height: 400px;">
        <div fxLayout="column" fxLayoutAlign="space-between center" style="padding:20px;" class="enterprise" fxFlex="50"
          fxFlex.xs="100">
          <h2>Provide payment information</h2>
          <p>
            This is the last part, if you have followed all the steps prior to this one, you will be able to enter your
            CC information and get on your way to better stats. If you ever had a GHIN registered with the email address
            you are using, this will fail if you did not save it in your profile. Don't forget to use the Promotion Code
            'Launch202' to get your 65% off.
          </p>
        </div>
        <div class="enterprise" fxFlex="100">
          <img src="assets/images/join.gif" width="100%">
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
          <button mat-raised-button class='orange-button big-button' (click)='getApp()'>START NOW</button>
        </div>
      </div>
    </div>
  </div>

  <div fxHide.xs fxShow.gt-xs fxLayout="column" fxLayoutAlign="start stretch">
    <div fxLayout="row" fxLayoutAlign="space-around stretch" fxLayoutalign.xs="center center"
      style="max-height: 500px;">
      <div fxFlex="45" fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start stretch">
        <div class="enterprise" fxFlex="50" fxLayout="column" fxLayoutAlign="center center" fxFlex="50">
          <img src="assets/images/create-account.png" width="80%">
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between center" style="padding:20px;" class="enterprise" fxFlex>
          <h2>Create an Account</h2>
          <p>
            As you can see, there are many options for you to get started with only one click on a button.
          </p>
          <button mat-raised-button class='orange-button big-button' (click)='startNow()'>GO NOW</button>
        </div>
      </div>
      <div fxFlex="45" fxLayout="row" fxLayoutAlign="start stretch">
        <div class="enterprise" fxFlex="50" fxLayout="column" fxLayoutAlign="center center">
          <img src="assets/images/find-golfer.png" width="80%">
          <span style="font-size: smaller;">*available only on the <a href="https://app.golfgameskeeper.com">mobile
              app</a></span>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between center" style="padding:20px;" class="enterprise"
          fxFlex="50">
          <h2>Verify your Handicap Id</h2>
          <p>
            Before we go any further, use our Search Golfer feature to see if you've had a Handicap Id before. If you've
            had a GHIN in the past, there is a good change that it was converted to a Handicap Id. Please note that you
            cannot do partial search on the first name. You can put a space, but it's preferred if you enter your full
            name. Even if your Hdcp Id is Inactive, it's still yours and you should use it in the next step.
          </p>
          <button mat-raised-button class='orange-button big-button' (click)='startNow()'>START TODAY</button>
        </div>
      </div>
    </div>
    <div style="height: 50px;"></div>
    <div fxLayout="row wrap" fxLayoutAlign="space-around stretch">
      <div fxFlex="30" fxLayout="column" fxLayoutAlign="space-between stretch" style="background-color: #f7f8f8;">
        <div fxLayout="column" fxLayoutAlign="center center" fxFlex="400px">
          <img height="80%" src="assets/images/profile-desktop.png">
        </div>
        <div style="background-color:black; color:white; width:100%;height: 70px; text-align: center;" fxFlex="70px">
          <h3>UPDATE YOUR PROFILE</h3>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between center" fxFlex>
          <p style="padding:10px 40px">
            Now that you have your correct Handicap Id, take a few more minutes to update it in your profile. If you
            didn't find one in the previous step, don't worry about it. We will create one for you after you join our
            club.
          </p>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxFlex="70px">
          <button mat-raised-button class='orange-button big-button' (click)='startNow()'>I like it</button>
        </div>
      </div>
      <div fxFlex="30" fxLayout="column" fxLayoutAlign="space-between stretch" style="background-color: #f7f8f8;">
        <div fxLayout="column" fxLayoutAlign="center center" fxFlex="400px">
          <img height="80%" src="assets/images/clubs-near-me.png">
        </div>
        <div style="background-color:black; color:white; width:100%;height: 70px; text-align: center;" fxFlex="70px">
          <h3>FIND A CLUB</h3>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between center" fxFlex>
          <p style="padding:10px 40px">
            You are now ready to find a club. From the menu (top left), click on find a club, you can find a club based
            on GPS Location or by providing your Zip Code. Select the club nearest to you.
          </p>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxFlex="70px">
          <button mat-raised-button class='orange-button big-button' (click)='startNow()'>Let's GO</button>
        </div>
      </div>
      <div fxFlex="30" fxLayout="column" fxLayoutAlign="space-between stretch" style="background-color: #f7f8f8;">
        <div fxLayout="column" fxLayoutAlign="center center" fxFlex="400px">
          <img width="65%" src="assets/images/card-info.png">
        </div>
        <div style="background-color:black; color:white; width:100%;height: 70px; text-align: center;" fxFlex="70px">
          <h3>JOIN</h3>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between center" fxFlex>
          <p style="padding:10px 40px">
            This is the last part, if you have followed all the steps prior to this one, you will be able to enter your
            CC information and get on your way to better stats. If you ever had a GHIN registered with the email address
            you are using, this will fail if you did not save it in your profile. Don't forget to use the Promotion Code
            'Launch202' to get your 65% off.
          </p>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxFlex="70px">
          <button mat-raised-button class='orange-button big-button' (click)='startNow()'>Let's Try it</button>
        </div>
      </div>
    </div>
  </div>
  <div style="padding:20px;">
    <h1 style="text-align: center;">See your stats</h1>
    <div fxLayout="row wrap" fxLayoutAlign="center start" fxLayoutGap="25px">
      <div>
        <img src="/assets/images/scoring_average.png">
      </div>
      <div>
        <img src="/assets/images/average_to_par.png">
      </div>
      <div>
        <img src="/assets/images/fairways.png">
      </div>
      <div>
        <img src="/assets/images/greens_in_regulation.png">
      </div>
      <div>
        <img src="/assets/images/putts.png">
      </div>
    </div>
  </div>

  <div style="height: 20px;"></div>
</section>